export default "__VITE_ASSET__DYSToR6E__"